import { z } from 'zod'

export const openFeedSchema = z.object({
  membersInFeed: z.number(),
  membersInRegularMode: z.number(),
  membersInChatMode: z.number(),
})
